import { Component, EventEmitter, Output } from '@angular/core';
import { emojiLongnameList } from '../emoji/emoji.pipe';

@Component({
  selector: 'fl-emoji-picker',
  template: `
    <fl-button flTrackingLabel="emojiPicker" (click)="handleEmojiButtonClick()">
        <fl-icon
            color="dark"
            size="small" hoverColor="primary"
            name="ui-smile" label="Pick an emoji"
        ></fl-icon>
    </fl-button>

    <div *ngIf="emojiPickerIsActive" class="EmojiPicker-card">
        <span title=""
            *ngFor="let emojiName of emojiLongnameList"
            class="EmojiPicker-item"
            [innerHtml]="emojiName | emoji"
            (click)="handleEmojiPick(emojiName)"
        ></span>
    </div>
    `,
  styleUrls: ['./emoji-picker.component.scss'],
})
export class EmojiPickerComponent {
  emojiPickerIsActive = false;
  emojiLongnameList = emojiLongnameList;

  @Output() emojiPicked = new EventEmitter<string>();

  handleEmojiPick(emojiName: string) {
    this.emojiPickerIsActive = false;
    this.emojiPicked.emit(emojiName);
  }

  handleEmojiButtonClick() {
    this.emojiPickerIsActive = !this.emojiPickerIsActive;
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/ko/webapp/src/app/@shared/ui/emoji-picker/emoji-picker.component.ts